import "../../assets/css/mentor.new.css";
import React, { useEffect, useState } from "react";
import { useLocation, useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as mentorActionSinda from "../../actions/mentorActionUMentor";
import { showToasterWithOk } from "../../utils/helpers";
import { Container, Row, Col } from "react-bootstrap";
import Filter from "../MentorIgnite/filter";
import Search from "../MentorIgnite/search";
import Details from "../MentorIgnite/details";
import ReactPaginate from "react-paginate";
import { setData } from "../../utils/helpers/localData";
import "./Umentor.css";


const queryString = require("query-string");

const Index = (props) => {
  const { actions, title, mentorsData, isAuth, userInfo, programmes } = props;

  const [modalShow, setModalShow] = useState(false);
  const [userData, setUserData] = useState({});
  const location = useLocation();

  const getMentor = async (e, mentorId) => {
    e.preventDefault();
    if (isAuth === false) {
      showToasterWithOk(
        "Thank you for browsing vLookUp! Help us create a meaningful mentoring engagement for you by registering in one simple step, or login if you already have an account."
      );
      history.push(`/login`);
    } else {
      const userId = userInfo.id;
      const request = {};
      request.userId = userId;
      request.mentorId = mentorId;
      actions.saveSelectMentor(request);
    }
  };

  const getUserDetails = (e, item) => {
    e.preventDefault();
    setModalShow(true);
    setUserData(item);
  };

  const setMentorWaitlistAvailability = (e, mentorId) => {
    e.preventDefault();
    const userId = userInfo.id;
    const request = {};
    request.userId = userId;
    request.mentorId = mentorId;
    actions.saveWaitlistMentor(request);
  };

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const queryStringParsed = queryString.parse(location.search);
    const request = {};
    if (params.get("sort")) {
      var sort = queryStringParsed["sort"];
      var direction = queryStringParsed["direction"];
      request.sort = sort;
      request.direction = direction;
    }
    if (params.get("page")) {
      var page = queryStringParsed["page"];
      request.page = page;
    }
    if (params.get("keyword")) {
      var keyword = queryStringParsed["keyword"];
      request.keyword = keyword;
    }
    if (params.get("domains")) {
      var domains = queryStringParsed["domains"];
      request.domains = domains;
    }

    if (params.get("is_available")) {
      var is_available = queryStringParsed["is_available"];
      request.is_available = is_available;
    }

    if (params.get("programmes")) {
      var programmes = queryStringParsed["programmes"];
      request.programmes = programmes;
    }
    if (params.get("mf_mental_health")) {
      var mf_mental_health = queryStringParsed["mf_mental_health"];
      request.mf_mental_health = mf_mental_health;
    }
    if (params.get("mf_certified_coach")) {
      var mf_certified_coach = queryStringParsed["mf_certified_coach"];
      request.mf_certified_coach = mf_certified_coach;
    }
    if (params.get("lgbtq_discussion")) {
      var lgbtq_discussion = queryStringParsed["lgbtq_discussion"];
      request.lgbtq_discussion = lgbtq_discussion;
    }

    if (isAuth === true) {
      actions.loadData(request, userInfo.id, "Mentor", "");
    } else {
      actions.loadData(request, 0, "Mentor", "");
    }
    setViewPage(request.page ? request.page - 1 : 0);
    document.title =
      "vLookUp | Creating impactful connections for women mentees";
    document
      .querySelector('meta[name="description"]')
      .setAttribute(
        "content",
        "vLookUp mentors are inspiring and empowering role models, have deep passion for growing talent and believe in fostering diversity."
      );
  }, [actions, title, location, userInfo, isAuth]);

  const history = useHistory();
  const resetPage = () => {
    history.push(location?.pathname);
    window.location.reload();
  };
  const searchData = (data) => {
    const params = new URLSearchParams(location.search);
    if (data.keyword) {
      params.set("keyword", data.keyword);
    }
    history.push({
      pathname: "/mentors",
      search: "?" + params,
    });
  };

  const handleFormClick = (item, action) => {
    actions.loadFormPop(action);
  };

  // console.log('pagination',pagination);

  useEffect(() => {
    actions.getAllProgrammes();
  }, []);
  const [viewpage, setViewPage] = useState(0);
  const handlePageClick = (data) => {
    setViewPage(data.selected);
    let page = data.selected + 1;
    const params = new URLSearchParams(location.search);
    params.set("page", page);
    history.push({
      pathname: location?.pathname,
      search: "?" + params,
    });
    window.scrollTo(0, 0);
  };

  useEffect(() => {
    const referringURL = document.referrer;
    const queryParams = new URLSearchParams(location.search);
    const isOlayUser = queryParams?.get("is_olay_user");

    if (isOlayUser === "yes") {
      const referringHostname = "ai-shu.in";
      const currentDate = new Date();
      const expirationDate = new Date(currentDate);
      expirationDate.setDate(currentDate.getDate() + 7);
      document.cookie = `redirectFrom=${referringHostname}; expires=${expirationDate.toUTCString()}; path=/`;
    }
  }, []);

  const handleProgram = (item) => {
    const baseUrl = `${window.location.protocol}//${window.location.host}/`;
    setData("program", "U-Mentor");
    localStorage.setItem("fromId", 27);
    window.open(baseUrl + "register?q=" + item, "_blank");
  };

  const handleLogin = () => {
    const baseUrl = `${window.location.protocol}//${window.location.host}/`;
    window.open(baseUrl + "login", "_blank");
  };

  return (
    <div className="body-font">
      <section class="UGoSection">
        <Container>
          <div class="UGoBanner">
            <a href="https://ugouniversity.org/" target="blank" class="UGoLogo">
              <img src="assets/images/U-GO-logo.svg" alt="U-GO Logo" />
            </a>
            <div className="UGoInnerBanner">
              <div class="UGoLeft">
                <h4>WELCOME TO</h4>
                <h2>U-MENTOR</h2>
                <p>Talent is universal, opportunity is not</p>
                <div class="poweredBY">
                  <strong>Powered by</strong>
                  <a href="https://www.vlookup.ai/" target="_blank">
                    <img
                      src="assets/images/logoBanner.svg"
                      alt="Vlookup Logo"
                    />
                  </a>
                </div>
              </div>

              <div class="UGoRight">
                <img src="assets/images/u-go-banner.svg" alt="Student" />
              </div>
            </div>
          </div>
        </Container>
      </section>

      <section className="UGo-content">
        <Container>
          <p>
            Education is just the beginning. With a mentor by your side, your
            voice grows stronger, your confidence deeper, and your dreams
            bolder. Your mentor is here to listen, encourage, and help guide you
            toward a brighter future. U-Mentor extends U-GO’s mission to ensure
            ambitious and talented young women have the tools to thrive beyond
            the classroom. Mentorship unlocks confidence, connection, and a
            clearer path to navigate a changing world ahead. <strong>Make a connection
              today.</strong>
          </p>
        </Container>
      </section>



      <section className="outer_main mentoring_page UGo_mentor_page">
        <Container className="page_heading text-center mb-5">

          <div className="col-md-12">
            <div className="text-center UGoBtn">
              {Object.keys(userInfo)?.length > 0 ? (
                <Link
                  to="/manage-profile"
                  target="_blank"
                  className="btn mr-2 mt-3 button-large-style UGo_mentorBtn"
                  style={{ padding: "10px 40px" }}
                >
                  My Dashboard
                </Link>
              ) : (
                <>
                  <div
                    onClick={() => handleLogin()}
                    className="btn mr-2 mt-3 button-large-style UGo_loginBtn"
                  >
                    LOG-IN
                  </div>

                  <div
                    onClick={() => handleProgram("Mentees")}
                    className="btn mr-2 mt-3 button-large-style UGo_registerBtn"
                  >
                    REGISTER <br></br>
                    SCHOLAR
                  </div>

                  <div
                    onClick={() => handleProgram("Mentor")}
                    className="btn mr-2 mt-3 button-large-style UGo_mentorBtn"
                  >
                    REGISTER <br></br>
                    MENTOR
                  </div>

                  {/* <Link
                    to={{
                      pathname: "/register?q=Mentor",
                      state: "ignite-women-mentoring",
                    }}
                    target="_blank"
                    className="btn mr-2 mt-3 button-large-style UGo_mentorBtn"
                  >
                    REGISTER <br></br>
                    MENTOR
                  </Link> */}
                </>
              )}
            </div>
          </div>
        </Container>
        <div className="page_content">
          <Container className="text-center">
            <h1 style={{ fontSize: "24px", fontWeight: "600", fontFamily: "davidextralight" }}>
              Find Your Mentor ({props.pagination.total}){" "}
            </h1>
          </Container>
          <Container>
            <div className="page_content_inner">
              <Search
                onClick={resetPage}
                onSearch={searchData}
                handleFormClick={handleFormClick}
                programmes={programmes}
              />
              <Row>
                <Col id="left_sidebar" md={4} lg={3}>
                  <Filter
                    onClick={resetPage}
                    onSearch={searchData}
                    handleFormClick={handleFormClick}
                  />
                </Col>

                {isAuth && (
                  <>
                    <Col md={8} lg={9}>
                      <Row className="mentor_list">
                        {mentorsData &&
                          mentorsData.map((item, key) => (
                            <Col xs={12} xl={4} lg={4} md={6} sm={6} key={key}>
                              <div className="outer position-relative">
                                <div className="mentor_img">
                                  {item?.is_reached_limit == 0 ? (
                                    item?.user_availability_check
                                      ?.availability == 1 ? (
                                      <span className="AvailabilityStatus m-3">
                                        Available
                                      </span>
                                    ) : (
                                      <span className="UnavailabilityStatus m-3">
                                        Unavailable
                                      </span>
                                    )
                                  ) : (
                                    <span className="UnavailabilityStatus m-3">
                                      Unavailable
                                    </span>
                                  )}
                                  {item.image && (
                                    <img
                                      src={item.image}
                                      alt="professional consultants for women"
                                    />
                                  )}
                                  {!item.image && (
                                    <img
                                      src={
                                        process.env
                                          .REACT_APP_STATIC_IMAGE_PATH +
                                        "mentor_women_two.png"
                                      }
                                      alt="professional consultants for women"
                                    />
                                  )}
                                </div>
                                <div className="mentor_info">
                                  <div className="">
                                    <span>
                                      {item.country_image_path && (
                                        <img src={item?.country_image_path} alt="professional consultants for women" className="country_flag" />
                                      )}
                                    </span>
                                    <h3>{item.full_name}</h3>
                                  </div>
                                  <h6>{item.position}</h6>
                                  <h5>{item.organization}</h5>
                                  <h5>{item.main_area}</h5>
                                </div>
                                <div className="mentor_btn">
                                  {" "}
                                  <div>
                                    {userInfo.role_id !== "Mentor" &&
                                      item.is_relationship === 0 &&
                                      item.is_mentor_terminate === 0 &&
                                      item.is_same_program === 1 && (
                                        <>
                                          {item.is_reached_limit === 0 &&
                                            item.user_availability === 1 ? (
                                            <Link
                                              to=""
                                              onClick={(e) => {
                                                getMentor(e, item.id);
                                              }}
                                            >
                                              Indicate as Preferred Mentor
                                            </Link>
                                          ) : (
                                            <Link
                                              to=""
                                              onClick={(e) => {
                                                setMentorWaitlistAvailability(
                                                  e,
                                                  item.id
                                                );
                                              }}
                                            >
                                              Waitlist for availability
                                            </Link>
                                          )}
                                        </>
                                      )}
                                    <Link
                                      to=""
                                      id={key}
                                      onClick={(e) => {
                                        getUserDetails(e, item);
                                      }}
                                    >
                                      {"Read More"}
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          ))}
                      </Row>
                      {props.pagination.total_pages && (
                        <ReactPaginate
                          breakLabel={"..."}
                          previousLabel={"<"}
                          nextLabel={">"}
                          forcePage={viewpage}
                          pageCount={props.pagination.total_pages}
                          marginPagesDisplayed={2}
                          pageRangeDisplayed={2}
                          onPageChange={(v) => handlePageClick(v)}
                          containerClassName={"pagination"}
                          subContainerClassName={"pages pagination"}
                          activeClassName={"active"}
                        />
                      )}
                    </Col>
                  </>
                )}

                {!isAuth && (
                  <Col md={8} lg={9}>
                    <Row className="mentor_list">
                      {mentorsData &&
                        mentorsData.map((item, key) => (
                          <Col xs={12} xl={4} lg={4} md={6} sm={6} key={key}>
                            <div className="outer position-relative">
                              <div className="mentor_img">
                                {item?.is_reached_limit == 0 ? (
                                  item?.user_availability_check?.availability ==
                                    1 ? (
                                    <span className="AvailabilityStatus m-3">
                                      Available
                                    </span>
                                  ) : (
                                    <span className="UnavailabilityStatus m-3">
                                      Unavailable
                                    </span>
                                  )
                                ) : (
                                  <span className="UnavailabilityStatus m-3">
                                    Unavailable
                                  </span>
                                )}
                                {item.image && (
                                  <img
                                    src={item.image}
                                    alt="find a career mentor online"
                                  />
                                )}
                                {!item.image && (
                                  <img
                                    src={
                                      process.env.REACT_APP_STATIC_IMAGE_PATH +
                                      "mentor_women_two.png"
                                    }
                                    alt="find a career mentor online"
                                  />
                                )}
                              </div>
                              <div className="mentor_info">
                                <div className="">
                                  <span>
                                    {item.country_image_path && (
                                      <img src={item?.country_image_path} alt="professional consultants for women" className="country_flag" />
                                    )}
                                  </span>
                                  <h3>{item.full_name}</h3>
                                </div>
                                <h6>{item.position}</h6>
                                <h5>{item.organization}</h5>
                                <h5>{item.main_area}</h5>
                              </div>
                              <div className="mentor_btn">
                                {" "}
                                <div>
                                  {userInfo.role_id !== "Mentor" && (
                                    <Link
                                      to=""
                                      onClick={(e) => {
                                        getMentor(e, item.id);
                                      }}
                                    >
                                      Indicate as Preferred Mentor
                                    </Link>
                                  )}
                                  <Link
                                    to=""
                                    id={key}
                                    onClick={(e) => {
                                      getUserDetails(e, item);
                                    }}
                                  >
                                    {"Read More"}
                                  </Link>
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                    </Row>
                    {props.pagination.total_pages && (
                      <ReactPaginate
                        previousLabel={"<"}
                        nextLabel={">"}
                        siblingCount={5}
                        forcePage={viewpage}
                        breakLabel={"..."}
                        breakClassName={"break-me"}
                        pageCount={props.pagination.total_pages}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={2}
                        onPageChange={(v) => handlePageClick(v)}
                        containerClassName={"pagination"}
                        subContainerClassName={"pages pagination"}
                        activeClassName={"active"}
                      />
                    )}
                  </Col>
                )}
              </Row>
            </div>
          </Container>
        </div>
      </section>

      <footer className="UGo-footer">
        <Container>
          <div className="footer-container">
            <div className="footer-left">
              <h4>Connect</h4>
              <div className="social-icons">
                <a href="https://www.linkedin.com/company/ugouniversity/" target="_blank">
                  <img src="assets/images/linkedin-icon.svg" alt="LinkedIn" />
                </a>
                <a href="https://www.instagram.com/ugouniversity/" target="_blank">
                  <img src="assets/images/instagram-icon.svg" alt="Instagram" />
                </a>
                <a href="https://www.youtube.com/@ugouniversity" target="_blank">
                  <img src="assets/images/youtube-icon.svg" alt="YouTube" />
                </a>
              </div>
              <p>
                Technical Support:{" "}
                <a href="mailto:support@vlookup.ai">support@vlookup.ai</a>
              </p>
            </div>

            <div className="footer-middle">
              <ul>
                <li>
                  <a href="https://ugouniversity.org/our-mission" target="_blank">Our Mission</a>
                </li>
                <li>
                  <a href="https://ugouniversity.org/our-team" target="_blank">Our Team</a>
                </li>
                <li>
                  <a href="https://ugouniversity.org/scholar-stories" target="_blank">Scholar Stories</a>
                </li>
                <li>
                  <a href="https://ugouniversity.org/news" target="_blank">News</a>
                </li>
                <li>
                  <a href="https://ugouniversity.org/events" target="_blank">Events</a>
                </li>
              </ul>
            </div>

            <div className="footer-right">
              <a href="https://ugouniversity.org/" target="blank" className="footer-logo">
                <img src="assets/images/U-GO-logo.svg" alt="U-GO Logo" />
              </a>
              <div class="poweredBY">
                <strong>Platform Powered by</strong>
                <a href="https://www.vlookup.ai/" target="_blank">
                  <img
                    src="assets/images/logoBanner.svg"
                    alt="Vlookup Logo"
                  />
                </a>
              </div>
            </div>
          </div>
        </Container>
      </footer>


      {modalShow && (
        <Details
          show={modalShow}
          userdata={userData}
          onHide={() => setModalShow(false)}
          centered
          size="xl"
          className="mentor_modal"
        />
      )}


    </div>
  );
};

function mapStateToProps(state) {
  return {
    mentorsData: state.mentorsData,
    pagination: state.pagination,
    isAuth: state.isAuth,
    userInfo: state.userInfo,
    programmes: state.programmes,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign(mentorActionSinda), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Index);
